export const EXPORTS_TAG_TYPE = 'Exports' as const;
